/**
 * Utility functions for conversation export functionality.
 */

/**
 * Parses a message to detect if it's a tool call and extract metadata.
 *
 * Supports patterns:
 * - "🔧 Calling tool: {toolName} with parameters:" (input)
 * - "🔧 Call to tool: {toolName} finished with result:" (output)
 *
 * Tool names can contain word characters (a-z, A-Z, 0-9, _) and hyphens (-).
 *
 * @param content - The message content to parse
 * @returns Object with tool call metadata or { isToolCall: false }
 */
export function parseToolCallMessage(
  content: string
): { isToolCall: boolean; toolName?: string; type?: 'input' | 'output'; body?: string } {
  // Check for "🔧 Calling tool: {toolName} with parameters:"
  // Pattern supports hyphens in tool names (e.g., search-sets, get-part-info)
  const callingMatch = content.match(/🔧 Calling tool: ([\w-]+) with parameters:(.*)/s);
  if (callingMatch) {
    return {
      isToolCall: true,
      toolName: callingMatch[1],
      type: 'input',
      body: callingMatch[2]?.trim() || '',
    };
  }

  // Check for "🔧 Call to tool: {toolName} finished with result:"
  const finishedMatch = content.match(/🔧 Call to tool: ([\w-]+) finished with result:(.*)/s);
  if (finishedMatch) {
    return {
      isToolCall: true,
      toolName: finishedMatch[1],
      type: 'output',
      body: finishedMatch[2]?.trim() || '',
    };
  }

  return { isToolCall: false };
}
